/**
 * Product variant constants to maintain consistency across the application
 * and eliminate magic strings
 */

/**
 * Available account sizes for trading accounts
 */
export const ACCOUNT_SIZES = {
  SIZE_2K: "$2k",
  SIZE_5K: "$5k",
  SIZE_10K: "$10k",
  SIZE_20K: "$20k",
  SIZE_50K: "$50k",
  SIZE_100K: "$100k",
  SIZE_200K: "$200k",
  SIZE_300K: "$300k",
} as const;

/**
 * Available trading platforms
 */
export const TRADING_PLATFORMS = {
  METATRADER_5: "Metatrader 5",
  MATCH_TRADE: "Match Trade",
  CTRADER: "cTrader",
} as const;

/**
 * Type definitions derived from constants
 */
export type AccountSize = (typeof ACCOUNT_SIZES)[keyof typeof ACCOUNT_SIZES];
export type TradingPlatform =
  (typeof TRADING_PLATFORMS)[keyof typeof TRADING_PLATFORMS];

/**
 * Challenge step types for trading challenges
 * These values match the challenge types used in the UI components
 */
export const CHALLENGE_STEPS = {
  ONE_STEP: "1 Step",
  TWO_STEP: "2 Step",
  THREE_STEP: "3 Step",
  INSTANT: "Instant",
  MINI: "Mini",
} as const;

/**
 * Challenge plan keys for internal use (locale files, restrictions)
 * These values use hyphen format for consistency with locale keys
 */
export const CHALLENGE_PLAN_KEYS = {
  ONE_STEP: "1-step",
  TWO_STEP: "2-step",
  THREE_STEP: "3-step",
  INSTANT: "instant",
  MINI: "mini",
} as const;

/**
 * Account types for UI components
 * These values are like this to match wordpress values, case sensitive
 */
export const ACCOUNT_TYPES = {
  STANDARD: "standard",
  INSTANT: "Instant",
  MINI: "Mini",
} as const;

/**
 * Type definitions derived from constants
 */
export type ChallengeStep =
  (typeof CHALLENGE_STEPS)[keyof typeof CHALLENGE_STEPS];
export type ChallengePlanKey =
  (typeof CHALLENGE_PLAN_KEYS)[keyof typeof CHALLENGE_PLAN_KEYS];
export type AccountType = (typeof ACCOUNT_TYPES)[keyof typeof ACCOUNT_TYPES];
